import React from "react";
import { baseURLImage, capitalizeFirstLetter, getNameProfile } from "../../../Utils/utils";
import PopoverContainer from "../Popover/PopoverContainer";

const ParticipantImageToolTip = (props) => {
  const { participant, imgCssClass, cssClass } = props;

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };



  return (
    <div>
      <PopoverContainer
        cssClass={`${cssClass} text-sm bg-gradient`}
        itemComponent={() => {}}
        toolTip={participant?.status_description ? participant?.status_description :`${capitalizeFirstLetter(participant?.first_name)} ${capitalizeFirstLetter(participant?.last_name)}`}
      >
        <img
          onError={(e) =>
            handleImageError(e, participant?.first_name, participant?.last_name)
          }
          className={imgCssClass}
          src={
            participant?.profile_picture
              ? baseURLImage(participant?.profile_picture)
              : getNameProfile(
                  participant?.first_name,
                  participant?.last_name || " "
                )
          }
          alt="participant_profile_picture"
        />
      </PopoverContainer>
      {/* {participant && participant.status_description && handleTooltipPosition()} */}
    </div>
  );
};

export default ParticipantImageToolTip;
